import { Instance, types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { Role } from './Role';

export const User = types.compose(
  BaseEntity,
  types
    .model('User', {
      userId: types.identifierNumber,
      firstName: types.string,
      lastName: types.string,
      userName: types.string,
      password: types.maybe(types.string),
      languageCode: types.maybe(types.string),
      email: types.string,
      isActive: types.boolean,
      secretaryId: types.maybe(types.number),
      roles: types.optional(types.array(Role), []),
    })
    .actions((self) => {
      const setFirstName = (firstName: string) => {
        self.firstName = firstName;
      };
      const setLastName = (lastName: string) => {
        self.lastName = lastName;
      };
      const setUserName = (userName: string) => {
        self.userName = userName;
      };
      const setPassword = (password: string) => {
        self.password = password;
      };
      const setLanguageCode = (languageCode: string) => {
        self.languageCode = languageCode;
      };
      const setEmail = (email: string) => {
        self.email = email;
      };
      const setIsActive = (isActive: boolean) => {
        self.isActive = isActive;
      };
      const getName = () => {
        return self.firstName + ' ' + self.lastName;
      };
      const getRole = (role: string) => {
        const res = self.roles.filter((rd) => rd.name === role);
        return (res.length > 0 ? res[0] : null) as Instance<typeof Role>;
      };
      return {
        setFirstName,
        setLastName,
        setUserName,
        setPassword,
        setLanguageCode,
        setEmail,
        setIsActive,
        getName,
        getRole,
      };
    }),
);
